import { Component, EventEmitter, inject, Output } from "@angular/core";
import { CreditPurchaseOption, CreditService } from "../stripe-product";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { PurchaseRepository, StripePayment } from "./purchase-repository";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { UserStore } from "../../stores";
import { OptionToValuePipe } from "../../pipes/option-to-value.pipe";

// Test card info
// 4242 4242 4242 4242 Succeeds and immediately processes the payment
// 4000 0000 0000 3220 3D Secure 2 authentication must be completed for a successful payment
// 4000 0000 0000 9995 Always fails with a decline code of insufficient_funds
// more test cards here https://stripe.com/docs/testing

@Component({
	selector: "jhm-stripe-purchase",
	templateUrl: "./purchase.component.html",
	styleUrls: ["./purchase.component.scss"],
	imports: [
		OptionToValuePipe
	]
})
export class PurchaseComponent
{
	@Output()
	public exit: EventEmitter<void> = new EventEmitter<void>();

	public isOpen: boolean = false;
	public selectedProduct: CreditPurchaseOption | null = null;
	public productOptions: CreditPurchaseOption[] = [
		CreditPurchaseOption.FIVE_CREDITS,
		CreditPurchaseOption.TEN_CREDITS,
		CreditPurchaseOption.TWENTY_CREDITS,
		CreditPurchaseOption.FIFTY_CREDITS
	];
	private purchaseRepository: PurchaseRepository;
	private router: Router;
	public ngDestroyed$: Subject<any> = new Subject();

	readonly userStore = inject(UserStore);

	public constructor(purchaseRepository: PurchaseRepository, router: Router)
	{
		this.purchaseRepository = purchaseRepository;
		this.router = router;
	}

	public pay(): void
	{
		const stripeKey: string = localStorage.getItem("STRIPE_PUBLIC") || "";
		if (this.selectedProduct !== null)
		{
			const stripePromise: Promise<Stripe | null> =
				loadStripe(stripeKey);
			const successUrl: string = this.router.url + "?stripe=success";
			const cancelUrl: string = this.router.url; // Just send it back from where it came + "?stripe=cancel";
			const payment: StripePayment = new StripePayment("Credits", "usd",
				CreditService.getStripeProductFromPurchaseOption(this.selectedProduct), successUrl, cancelUrl);
			stripePromise.then((stripe: Stripe | null) =>
			{
				this.purchaseRepository.uploadeFile(payment).subscribe((data: any) =>
				{
					stripe?.redirectToCheckout({
						sessionId: data.id
					});
				});
			});
		}
	}

	public selectProduct(product: CreditPurchaseOption): void
	{
		this.selectedProduct = product;
	}

	public cancel(): void
	{
		this.userStore.fetchUser();
		this.exit.emit();
	}
}
